import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" mdxType="Hero" />
    <h1 {...{
      "id": "resources-and-support"
    }}>{`Resources and support`}</h1>
    <p>{`Adobe I/O Runtime is built on top of Apache OpenWhisk. This is why many of the resources written for Apache OpenWhisk apply to Adobe I/O Runtime, too: blogs, documentation and references, and so forth.`}</p>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <p>{`For a starter, a good resource to check is the `}<a parentName="p" {...{
        "href": "https://github.com/apache/incubator-openwhisk/tree/master/docs"
      }}>{`Apache OpenWhisk repository`}</a>{`.`}</p>
    <h2 {...{
      "id": "social-media"
    }}>{`Social media`}</h2>
    <p>{`You can follow up our team on `}<a parentName="p" {...{
        "href": "https://twitter.com/adobeio"
      }}>{`Twitter`}</a>{`, `}<a parentName="p" {...{
        "href": "https://medium.com/adobetech/tagged/platform"
      }}>{`Medium`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/channel/UCDtYqOjS9Eq9gacLcbMwhhQ"
      }}>{`Youtube`}</a>{`.`}</p>
    <h2 {...{
      "id": "support"
    }}>{`Support`}</h2>
    <p>{`If you have issues with Adobe I/O Runtime, you can use our `}<a parentName="p" {...{
        "href": "https://forums.adobe.com/community/adobe-io/adobe-io-runtime"
      }}>{`Adobe I/O Runtime Forum`}</a>{`.`}</p>
    <p>{`If you have issues with the documentation, you can always submit a pull request.`}</p>
    <p>{`Check the `}<a parentName="p" {...{
        "href": "faq.md"
      }}>{`FAQ`}</a>{` for some of the most common questions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      